export default __webpack_public_path__ + "static/media/img3.82ce6a0c.jpeg";